import { Card } from "primereact/card";
import { useParams } from "react-router-dom";

import CustomeButton from "~/components/Button";
import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";
import API_ROUTES from "~/api-routes";
import AdminOnly from "~/components/AdminOnly";
import FileUploadModal from "~/components/Processes/conversations/FileUploadModal";

import CoreEntityAttachmentTable from "./CoreEntityAttachmentTable";
import useCoreEntityAttachments from "./useCoreEntityAttachments";
import Notification from "../notification/Notification";
import TemporaryNotification from "~/components/toast-notification/AttachmentTemporaryNotification";
import DocumentConfirmationDialog from "~/components/confirmation-dialog/DocumentConfirmationDialog";
import AttachmentSuccess from "~/components/toast-notification/AttachmentSuccess";
import "./core-entity-attachments.scss";
import { mergeCategories } from "~/Pages/Requests/components/new-request-modal/utils";
import { useEffect, useRef, useState } from "react";
import useAttachmentFilter from "~/hooks/useAttachmentFilter";
import BlobFilter from "~/components/BlobFilter";
import FilterChip from "~/components/FilterChip";

const CoreEntityAttachments = () => {
  const { id } = useParams();

  const {
    attachments,
    loading,
    page,
    rows,
    totalRecords,
    onPageChange,
    isDataAvailable,
    entitydata,
    showUploadModal,
    fileSupported,
    setShowUploadModal,
    uploadFileHandler,
    requestdata,
    isFileUploaded,
    successMessage,
    setSuccessMessage,
    isAuditSidebarVisible,
    setAuditSidebarVisible,
    first,
    handleDeleteDocument,
    attachmentConfirmModal,
    setAttachmentConfirmModal,
    handleConfirmDelete,
    handleRestoreAttachment,
    temporaryMessage,
    isAttachmentLoader,
    setTemporaryMessage,
    restoreMessage,
    setRstoreMessage,
    role,
    selectedItems,
    filterData,
    setFilterData,
    removeFnRef,
    handleRemoveFilter,
    handleFilterChange,
    filterLoading,
    onSortOrderChange,
    onFilterApply,
    allData,
    filterPageChange,
    currentPage,
    fetchOfficerAttachments,
  } = useCoreEntityAttachments();

  const auditLabels = () => {
    return {
      create: "File Uploaded",
      update: "Address Updated",
      delete: "File(s) Deleted",
    };
  };

  return (
    <Card className="gen-card h-full">
      <div className="flex justify-content-between align-items-center mb-5">
        <p className="heading-primary">Attachments</p>
        <div className="flex gap-2">
          <AdminOnly>
            <CustomeButton
              label="View History"
              icon="pi pi-history"
              iconPos="right"
              onClick={() => setAuditSidebarVisible(true)}
            />
          </AdminOnly>
          <BlobFilter
            onApply={({ value, group }) => {
              setFilterData(value);
            }}
            onRemove={(fn) => (removeFnRef.current = fn)}
            onFilterChange={({ value, grouped }) => {
              handleFilterChange(grouped);
            }}
            showEntity={false}
            showServiceLine={false}
            showYears={false}
            serviceLine={"Entities +"}
            disabled={!isDataAvailable}
          />
          <AdminOnly>
            <CustomeButton
              label="Upload File"
              variant="contained"
              icon="pi pi-plus"
              iconPos="right"
              onClick={() => {
                setShowUploadModal(true);
              }}
            />
          </AdminOnly>
        </div>
      </div>
      <FilterChip
        filterData={filterData}
        removeFilter={(id) => {
          handleRemoveFilter(id);
        }}
      />
      <Notification
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
      />
      <TemporaryNotification
        onUndo={handleRestoreAttachment}
        successMsg={temporaryMessage}
        setMessages={setTemporaryMessage}
      />
      <AttachmentSuccess
        successMsg={restoreMessage}
        setMessages={setRstoreMessage}
      />
      <div className="mt-4">
        <CoreEntityAttachmentTable
          attachments={selectedItems.length ? allData : attachments}
          loading={selectedItems.length ? filterLoading : loading}
          page={selectedItems.length ? currentPage : page}
          rows={rows}
          first={selectedItems.length ? page - 1 : first}
          totalRecords={
            selectedItems.length ? allData.length : attachments?.length
          }
          onPageChange={
            selectedItems.length
              ? (e) => {
                  filterPageChange(e.page + 1);
                }
              : onPageChange
          }
          isDataAvailable={
            selectedItems.length ? allData.length : isDataAvailable
          }
          setOpenDialog={setShowUploadModal}
          handleAttachmentDelete={handleDeleteDocument}
          onSortOrderChange={
            selectedItems?.length ? onSortOrderChange : undefined
          }
          isFilterApplied={selectedItems.length}
          onRefetch={
            selectedItems?.length ? onFilterApply : fetchOfficerAttachments
          }
        />
      </div>
      <FileUploadModal
        entitydata={entitydata}
        showModal={showUploadModal}
        fileSupported={fileSupported}
        hideUploadModal={() => setShowUploadModal(false)}
        setUploadedFile={uploadFileHandler}
        getService={() => {
          return { name: "Core Entity Information" };
        }}
        requestdata={requestdata}
        loading={!isFileUploaded}
        close={false}
        relatedType={"ENTITIES_PLUS"}
        categories={mergeCategories(["Entities +"], role)}
      />

      {isAuditSidebarVisible && (
        <AuditSidebar
          heading="Attachments"
          endpoint={API_ROUTES.FETCH_ATTACHMENT_AUDIT}
          id={id}
          objectType="ENTITIES_PLUS"
          setSidebarToggle={setAuditSidebarVisible}
          sidebarToggle={isAuditSidebarVisible}
          labels={auditLabels}
        />
      )}
      {attachmentConfirmModal && (
        <DocumentConfirmationDialog
          visible={attachmentConfirmModal}
          closeModal={() => setAttachmentConfirmModal(false)}
          handleSave={handleConfirmDelete}
          isLoader={isAttachmentLoader}
        />
      )}
    </Card>
  );
};

export default CoreEntityAttachments;
